import { Component, OnInit, Input, ViewChild } from "@angular/core";
import {
  animate,
  state,
  style,
  transition,
  trigger
} from "@angular/animations";
import { Request } from "src/app/parametrage/core/model/request";
import { Dossier } from 'src/app/suivi-portefeuille/core/model/dossier';
import { Echeance } from 'src/app/suivi-portefeuille/core/model/echeance';
import { Paiement } from 'src/app/suivi-portefeuille/core/model/paiement';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { DossierService } from 'src/app/suivi-portefeuille/core/service/dossier.service';
import { EcheanceService } from 'src/app/suivi-portefeuille/core/service/echeance.service';
import { PaiementService } from 'src/app/suivi-portefeuille/core/service/paiement.service';
import { RequestService } from 'src/app/parametrage/core/service/request.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
interface Alert {
  type: string;
  message: string;
}

@Component({
  selector: "app-echeance",
  templateUrl: "./echeance.component.html",
  styleUrls: ["./echeance.component.scss"],
  //
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
  //
})
export class EcheanceComponent implements OnInit {
  pressButton: Boolean = false;

  alerts: Alert[] = [];
  dossier: Dossier;
  requestEncours: Request;
  @Input() numDossier: String;


  @ViewChild(MatPaginator, { static: false })
  paginator: MatPaginator;
  @ViewChild(MatSort, { static: false })
  sort: MatSort;
  dataSource: MatTableDataSource<Echeance>;
  isLoadingResults = false;

  data: Echeance[] = [];


  echeances: Echeance[];
  paiements: Paiement[];
  paiementArray: Array<Paiement[]> = [];

  displayedStudentsColumnsList: string[] = [
    "numEcheance",
    "montantEcheance",
    "dateEcheance",
    "statutEcheance",
    "actions"
  ];

  constructor(
    private _dossierService: DossierService,
    private _echeanceService: EcheanceService,
    private _paiementService: PaiementService,
    private _requestService: RequestService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    //    this.numDossier = params["numDossier"];
    this.getDossierByNumDossier(this.numDossier);
    this.getEcheanceListByNumDossiers(this.numDossier);
    //this.getRequestEncoursAttentePaiementByNumDossier(this.numDossier);

  }

  getDossierByNumDossier(numDossier) {
    this._dossierService.getDossierByNumDossier(numDossier).subscribe(
      data => {
        this.dossier = data;
      },
      error => {
        console.log(error);
      }
    );
  }


  getEcheanceListByNumDossiers(numDossier) {
    this.isLoadingResults = true;
    this._echeanceService.getEcheanceListByNumDossier(numDossier).subscribe(
      data => {
        this.data = data;
      },
      error => {
        this.isLoadingResults = false;
      },
      () => {
        if (this.data == null) {
          this.data = [];
        }
        this.dataSource = new MatTableDataSource(this.data);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.isLoadingResults = false;
      }
    );
  }

  getPaiementListByNumEcheance(numEcheance) {
    this._paiementService.getPaiementListByNumEcheance(numEcheance).subscribe(
      data => {
        this.paiements = data;
        this.paiementArray[numEcheance] = this.paiements;
      },
      error => {
        console.log(error);
      }
    );
  }

  getRequestEncoursAttentePaiementByNumDossier(numDossier) {
    this._requestService
      .getRequestEncoursAttentePaiementByNumDossier(numDossier)
      .subscribe(
        data => {
          this.requestEncours = data;
        },
        error => {
          console.log(error);
        }
      );
  }

  analyserDossier() {
    this._dossierService.analyserDossier(this.numDossier).subscribe(
      data1 => {
        this.alerts.push({
          type: "success",
          message: "Analyse efféctuée"
        });

        this.getDossierByNumDossier(this.numDossier);
        this.getEcheanceListByNumDossiers(this.numDossier);
        this.getRequestEncoursAttentePaiementByNumDossier(this.numDossier);
      },
      error1 => {
        console.log(error1);
        this.alerts.push({
          type: "danger",
          message: error1.error.message
        });
      }
    );
  }

  lancerProcedure() {
    this._dossierService.lancerProcedure(this.numDossier).subscribe(
      data1 => {
        this.alerts.push({
          type: "success",
          message: "Dossier lancer"
        });
        this.requestEncours = data1;
      },
      error1 => {
        this.alerts.push({
          type: "danger",
          message: error1.error.message
        });
        console.log(error1);
      }
    );
  }

  close(alert: Alert) {
    this.alerts.splice(this.alerts.indexOf(alert), 1);
  }
}
